import { VehiculoCorporativosEntity } from "../masivos/datosGenerales/entities/vehiculo_entity";

export class ClienteLogin {
    constructor(
        public Cedula?: string,
        public Token?: string,
        public Masivos?: Cliente[],
        public Empresa?: ClienteXCiudad[],
        public VAM?: ClienteVAM[],
        public Corporativo?: ClienteResumen[],
        public Menu?: Menu[],
        public CodigoUsuario?: number,
        public TipoCliente?: number,
        public Error?: number,
        public Mensaje?: string) { }
}

export class ClienteVAM{
    constructor(
        public CodigoCiudad?: number,
        public CodigoCliente?: number,
        public CodigoUnidad?: number,
        public NombreEmpresa?: string
    ){

    }
}
export class ClienteResumen{
    constructor(
        public Cedula?: string,
        public Nombre?: string,
        public Cliente?: string,
        public Codigocliente?: number,
        public Ciudad?: number,
        public Unidad?: number,
        public Vehiculos?: VehiculoCorporativosEntity[],
    ){

    }
}


export class CiudadClienteNombre{
    constructor(
        public CodigoCliente?: number,
        public CodigoCiudad?: number,
        public NombreCombo?: string,
        public Unidad?: number,
        public NombreEmpresa?: string,
        public idUnico?: number
    ){}
}

export class Cliente {
    constructor(
        public CodigoCliente?: number,
        public Ciudad?: number,
        public TipoCliente?: number
    ) { }
}

export class Menu {
    constructor(
        public Nombre?: string,
        public CodigoMenu?: number,
        public Descripcion?: string,
        public Segmento?: number,
        public Ruta?: string,
        public Hijos?: Menu[],
        public Estado?: number,
        public Seleccionado?: boolean,
        public Padre?: number,
        public Habilitado?: boolean,
        public Logo?: string
    ) { }
}

export class ClienteXCiudad {
    constructor(
        public CodigoCliente?: number,
        public Ciudad?: number,
        public Nombre?: string,
        public Unidades?: Unidades[],
        public Cedula?: string,
        public CodigoGrupo?: number,
        public CodigoUnidad?: number
    ) { }
}

export class Unidades {
    constructor(
        public Codigo?: number,
        public Ciudad?: number,
        public Segmento?: number
    ) { }
}

export class ConsultaMenu {
    constructor(
        public Empresa?: ClienteXCiudad,
        public Empresas?: ClienteXCiudad[],
        public Cedula?: string,
        public REG_COD?: number
    ) { }
}

export class MenuXUsuario {
    constructor(
    public Nombre?: string,
    public CodigoUsuario?: number,
    public CodigoCliente?: number,
    public Menus?: Menu[]){}
}

export class UsuarioVamTit {
    constructor(
    public CodigoCliente?: number,
    public CodigoCiudad?: number,
    public CodigoUnidad?: number,
    public Cedula?: string){}
}
export class ConsultaCliente {
    constructor(
        public Cliente?: number,
        public Ciudad?: number,
        public Grupo?: number,
        public Unidad?: number
    ) { }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/login/cliente_login.ts